// 注意！ 这个文件只是为了方便管理
// 其他业务要获取 token 统一使用本目录下 index.js 内的方法

export const TOKEN_KEY = "token_v2";
const TOKEN_SET_TIME = "token_time";

export function set(val) {
    localStorage.setItem(TOKEN_KEY, val);
    localStorage.setItem(TOKEN_SET_TIME, Date.now());
}
export function get() {
    return localStorage.getItem(TOKEN_KEY);
}
export function getSetTime() {
    const time = localStorage.getItem(TOKEN_SET_TIME);
    return time ? parseInt(time, 10) : 0;
}
export function clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_SET_TIME);
}
